/* eslint-disable react-hooks/exhaustive-deps */
import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import { db } from "~db/db";
import prepareForOptions from "~services/utils/prepareForOptions";

const useFunilObraFonteCaptacao = ({ formikRef, name = "funilObraFonteCaptacaoId" }) => {
  const fonteCaptacaoSelect = useSelect("funilObraFonteCaptacaoId");
  const [fila, setFila] = useState(null);
  const [fonteCaptacao, setFonteCaptacao] = useState(null);

  const [fontesCaptacao, setFontesCaptacao] = useState([]);

  useEffect(() => {
    const fetchFontesCaptacao = async () => {
      const result = [];
      await db.funilObraFonteCaptacao.filter((a) => a.ativo).each((item) => result.push(item));
      setFontesCaptacao(result);
    };

    fetchFontesCaptacao();
  }, []);


  const optionFontesCaptacao = useMemo(() => prepareForOptions(fontesCaptacao, ['nome'], 'id'), [fontesCaptacao]);

  function onChangeFonteCaptacao(e) {
    fonteCaptacaoSelect.upDateValue(e.value);
    fonteCaptacaoSelect.upDateDefaultValue(e || "");
    formikRef.current.setFieldValue(name, e.value);
    setTimeout(() => formikRef.current.setFieldTouched(name, true));
    setFonteCaptacao(e.value);
  }

  function SetSelectFonteCaptacao(id) {
    if (optionFontesCaptacao?.length) {
      const fonteCaptacao = optionFontesCaptacao.find((o) => o.value === id);
      if (fonteCaptacao)
        onChangeFonteCaptacao(fonteCaptacao);

      setFila(null);
    } else {
      setFila(id);
    }
  }

  useEffect(() => {
    if (fila && optionFontesCaptacao?.length > 0) {
      SetSelectFonteCaptacao(fila);
    }
  }, [fila, optionFontesCaptacao])

  const fonteCaptacaoSelecionado = useMemo(() => {
    if (fonteCaptacao && fonteCaptacao != 0)
      return fontesCaptacao?.find(e => e.id == fonteCaptacao);
    return null;
  }, [fonteCaptacao])

  return {
    fonteCaptacaoSelecionado,
    fontesCaptacao,
    optionFontesCaptacao,
    onChangeFonteCaptacao,
    SetSelectFonteCaptacao,
    fonteCaptacao,
    fonteCaptacaoSelect,
    setFonteCaptacao
  };
}

export default useFunilObraFonteCaptacao;